var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',{attrs:{"config":_vm.groupConfig}},[_vm._l((_vm.layer.layers),function(l){return [(l.type === 'Image')?_c('m-image',{key:l.id,attrs:{"layer":l}}):_vm._e(),_vm._v(" "),(l.type === 'Group')?_c('group',{key:l.id,attrs:{"layer":l}}):_vm._e(),_vm._v(" "),(l.type === 'Printarea')?_c('print-area',{key:l.id,attrs:{"layer":l}}):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a215c1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mockup/Group.vue
// module id = 343
// module chunks = 0